export function compose(...functions: Function[]) {
  return (Component: any) => {
    return functions.reduceRight((wrapped, hoc) => hoc(wrapped), Component)
  }
}
